(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marigold-mantras"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const root=document.getElementById('marigold-mantras');
  if(!root||root.dataset.ready==='true')return;
  root.dataset.ready='true';

  const field=root.querySelector('.mm-field');
  const reveal=root.querySelector('.mm-reveal');
  const titleEl=root.querySelector('.mm-mantra');
  const artistEl=root.querySelector('.mm-artist');
  const meaningEl=root.querySelector('.mm-meaning');
  const contextEl=root.querySelector('.mm-context');
  const playerWrap=root.querySelector('.mm-player-wrap');
  const sourceLink=root.querySelector('.mm-source');
  const close=root.querySelector('.mm-close');
  const again=root.querySelector('.mm-again');
  const flowerSrc='https://cdn.shopify.com/s/files/1/0918/4910/files/marigold-clean-approved.png?v=1790917326';

  const flowers=[
    {title:'Om Shantih',artist:'Sharon Gannon',meaning:'A prayer for peace within, peace around us, and peace throughout existence.',youtube:'cEwma5Yb1OY',source:'https://www.youtube.com/watch?v=cEwma5Yb1OY'},
    {title:'Lokah Samastah Sukhino Bhavantu',artist:'Sharon Gannon',meaning:'May all beings everywhere be happy and free.',youtube:'OLDRpB_4fkQ',source:'https://www.youtube.com/watch?v=OLDRpB_4fkQ'},
    {title:'The 23rd Psalm',artist:'Bobby McFerrin',meaning:'A prayer of trust, guidance, protection, and being carried through darkness.',youtube:'bJixdpZ5m1o',source:'https://www.youtube.com/watch?v=bJixdpZ5m1o'},
    {title:'Imagine',artist:'John Lennon',meaning:'A vision of humanity beyond division, possession, and conflict.',youtube:'rAn-AWXtHv0',source:'https://www.youtube.com/watch?v=rAn-AWXtHv0'},
    {title:'Sri Venkateswara Suprabhatam',artist:'M. S. Subbulakshmi',meaning:'A sacred morning invocation awakening and praising Lord Venkateswara.',context:'Lord Venkateswara is a beloved form of Vishnu, associated with protection, abundance, compassion, and grace.',youtube:'krGYd5tZe0A',source:'https://www.youtube.com/watch?v=krGYd5tZe0A'},
    {title:'Ram',artist:'Neem Karoli Baba / Maharaj-ji',meaning:'The divine name repeated as remembrance, love, devotion, and refuge.',context:'Neem Karoli Baba, known as Maharaj-ji, was an Indian saint whose teachings centered on love, service, remembrance of God, and compassion.',audio:'https://babaneebkarorimaharaj.com/wp-content/uploads/2021/09/Neem-Karoli-Baba-chanting-RAMs-name-2-daily-practice.mp3',source:'https://babaneebkarorimaharaj.com/'},
    {title:'Speaking Tree',artist:'Joy Harjo',meaning:'A meditation on kinship with the living world and the act of listening.',context:'Joy Harjo is a Muscogee poet, musician, and former U.S. Poet Laureate.',youtube:'xzxZYlHGDhM',source:'https://www.youtube.com/watch?v=xzxZYlHGDhM'},
    {title:'Earth Spirit',artist:'R. Carlos Nakai',meaning:'A contemplative flute piece rooted in breath, land, and stillness.',context:'R. Carlos Nakai is a Native American flutist of Navajo-Ute heritage.',source:'https://canyonrecords.com/product/r-carlos-nakai-earth-spirit-cr-612/'},
    {title:'Om Namah Shivaya',artist:'Krishna Das',meaning:'I bow to the divine presence within all.',youtube:'PTc8X37oJBE',source:'https://www.youtube.com/watch?v=PTc8X37oJBE'},
    {title:'Om Gam Ganapataye Namaha',artist:'Sat-Chit',meaning:'An invocation to Ganesha for wisdom, groundedness, and the clearing of obstacles.',youtube:'HKQmZs_gnSM',source:'https://www.youtube.com/watch?v=HKQmZs_gnSM'},
    {title:'Gayatri Mantra',artist:'Deva Premal',meaning:'A prayer asking divine light to illuminate the mind and awaken wisdom.',youtube:'se_WP1Mh0g8',source:'https://www.youtube.com/watch?v=se_WP1Mh0g8'},
    {title:'Om Namo Bhagavate',artist:'Deva Premal',meaning:'A liberation mantra for recognizing the divine presence within ourselves and all beings.',youtube:'jMxlPS9aK7o',source:'https://www.youtube.com/watch?v=jMxlPS9aK7o'},
    {title:'Om Shreem Mahalakshmiyei Namaha',artist:'Deva Premal',meaning:'A traditional mantra invoking Lakshmi and the energy of abundance, gratitude, beauty, and grace.',audio:'https://devapremalmiten.com/wp-content/uploads/audio/Precarious_Times/06-Om_Shreem_Mahalakshmiyei_Namaha.mp3',source:'https://devapremalmiten.com/music/mantras-for-precarious-times/'},
    {title:'My Sweet Lord',artist:'George Harrison',meaning:'A devotional longing for direct experience of the divine, weaving Western praise with Hare Krishna.',youtube:'SP9wms6oEMo',source:'https://www.youtube.com/watch?v=SP9wms6oEMo'},
    {title:'Man in the Mirror',artist:'Michael Jackson',meaning:'A song about personal responsibility and beginning change with yourself.',youtube:'PivWY9wn5ps',source:'https://www.youtube.com/watch?v=PivWY9wn5ps'},
    {title:'People Have the Power',artist:'Patti Smith',meaning:'A collective invocation of courage, shared responsibility, and the power people have to shape the world together.',youtube:'pPR-HyGj2d0',source:'https://www.youtube.com/watch?v=pPR-HyGj2d0'},
    {title:'Om Mani Padme Hum',artist:'Dalai Lama',meaning:'A Tibetan Buddhist mantra invoking compassion and awakening.',context:'“Compassion,” from the album Inner World.',soundcloud:'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A827687761&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true',source:'https://soundcloud.com/dalailama-innerworld/compassion'},
    {title:'Ong Namo Guru Dev Namo',artist:'Snatam Kaur',meaning:'I bow to the subtle divine wisdom and the teacher within.',youtube:'0nP23NQA8A4',source:'https://www.youtube.com/watch?v=0nP23NQA8A4'},
    {title:'Hanuman Chalisa',artist:'Krishna Das',meaning:'A devotional hymn invoking Hanuman’s courage, strength, devotion, protection, and service.',context:'Hanuman is the beloved devotee of Ram, revered as an embodiment of devotion, courage, and selfless service.',youtube:'VvLPrWqBjl8',source:'https://www.youtube.com/watch?v=VvLPrWqBjl8'},
    {title:'Lalita Lalita Sri Lalita',artist:'Amma',meaning:'A devotional song invoking Lalita, a form of the Divine Mother.',context:'Sung by Amma, Mata Amritanandamayi.',youtube:'lk_o78c6DLk',source:'https://www.youtube.com/watch?v=lk_o78c6DLk'},
    {title:'Wild Geese',artist:'Mary Oliver, read by Mary Oliver',meaning:'A reminder of belonging, self-forgiveness, and our place within the natural world.',youtube:'T_nKg3TBzpU',source:'https://www.youtube.com/watch?v=T_nKg3TBzpU'},
    {title:'Mindful Breathing',artist:'Trevor Hall feat. Thich Nhat Hanh',meaning:'A meditation on returning to the present moment through the simple awareness of breathing.',youtube:'iiVFNKgWCgc',source:'https://www.youtube.com/watch?v=iiVFNKgWCgc'},
    {title:'Savitri',artist:'Sri Aurobindo · recited by The Mother',meaning:'A spiritual epic about love, death, transformation, and the possibility of a greater consciousness.',context:'The Mother’s recorded recitations are preserved within the Sri Aurobindo tradition.',youtube:'-489F6wnib0',source:'https://www.youtube.com/watch?v=-489F6wnib0'},
    {title:'Dream Variations',artist:'Langston Hughes · Sweet Honey in the Rock',meaning:'A dream of freedom, movement, rest, and belonging beneath an open sky.',youtube:'BBBayE57ywY',source:'https://www.youtube.com/watch?v=BBBayE57ywY'},
    {title:'A Love Supreme: Acknowledgement',artist:'John Coltrane',meaning:'A devotional work of gratitude, surrender, praise, and love of God.',youtube:'Dmx2WuUPVcs',source:'https://www.youtube.com/watch?v=Dmx2WuUPVcs'},
    {title:'The Miracle Mantra of Guru Ram Das',artist:'Gurucharan Khalsa & Gurusangat Singh',meaning:'A journey from personal wisdom into the infinite and back into a life of service.',context:'The album includes Gurucharan’s spoken introduction to the mantra.',youtube:'lbtxHVKULmE',source:'https://www.youtube.com/watch?v=lbtxHVKULmE'},
    {title:'Japji Sahib',artist:'Guru Nanak · recited by Bhai Sahib Singh',meaning:'A foundational Sikh prayer on truth, divine order, humility, remembrance, and living in harmony with the One.',youtube:'KQIeS-hKWPk',source:'https://www.youtube.com/watch?v=KQIeS-hKWPk'},
    {title:'Shanti / Ashtangi',artist:'Madonna',meaning:'A Sanskrit devotional invocation shaped into a modern pop meditation.',youtube:'y8VN8WCMWpE',source:'https://www.youtube.com/watch?v=y8VN8WCMWpE'},
    {title:'Woodstock',artist:'Joni Mitchell',meaning:'A song about peace, gathering, returning to nature, and remembering that we belong to something larger than ourselves.',youtube:'ZzZTSfXcHYI',source:'https://www.youtube.com/watch?v=ZzZTSfXcHYI'},
    {title:'Clair de lune',artist:'Claude Debussy',meaning:'Moonlight translated into music: stillness, tenderness, mystery, and beauty without words.',youtube:'WKU8DJzipW4',source:'https://www.youtube.com/watch?v=WKU8DJzipW4'},
    {title:'Ubi Caritas',artist:'Gregorian chant · Verbum Gloriae',meaning:'Where charity and love are, God is there.',audio:'https://www.verbumgloriae.es/wp-content/uploads/2025/08/Ubi-caritas.ogg',source:'https://www.verbumgloriae.es/project/ubi-caritas/'},
    {title:'Lalitha Ashtotram',artist:'Craig Pruess & Ananda',meaning:'A devotional recitation of the 108 sacred names of the Divine Mother.',context:'From the album 108 Sacred Names of Mother Divine. Vocals by Ananda; music and production by Craig Pruess.',youtube:'RJgHGXhTnG8',source:'https://www.youtube.com/watch?v=RJgHGXhTnG8'},
    {title:'Healing and Shuniya',artist:'Guru Dev Singh',meaning:'A teaching on stillness, compassion, and our interconnectedness.',context:'Guru Dev Singh, teacher of Sat Nam Rasayan. A spoken teaching shared by SikhNet.',youtube:'E7oc0SkJeaQ',source:'https://www.youtube.com/watch?v=E7oc0SkJeaQ'},
    {title:'Ho‘oponopono — Part 1 of 9',artist:'Dr. Ihaleakalā Hew Len',meaning:'An introduction to his practice of Ho‘oponopono.',context:'The first video in a nine-part teaching series.',youtube:'OL972JihAmg',source:'https://www.youtube.com/watch?v=OL972JihAmg'}
  ];

  let lastIndex=-1;
  let lastBloom=null;
  let inView=true;
  const reducedMotion=window.matchMedia('(prefers-reduced-motion:reduce)');
  const status=root.querySelector('.mm-player-status');
  const controller=new AbortController();
  const listen=(element,event,handler)=>element.addEventListener(event,handler,{signal:controller.signal});

  const burst=(b)=>{
    if(reducedMotion.matches)return;
    const r=b.getBoundingClientRect();
    const garden=root.getBoundingClientRect();
    for(let i=0;i<8;i++){
      const p=document.createElement('span');
      const a=(Math.PI*2/8)*i+(Math.random()*.45);
      const d=34+Math.random()*46;
      p.className='mm-burst';
      p.style.left=(r.left+r.width/2-garden.left)+'px';
      p.style.top=(r.top+r.height/2-garden.top)+'px';
      p.style.setProperty('--x',(Math.cos(a)*d)+'px');
      p.style.setProperty('--y',(Math.sin(a)*d)+'px');
      p.style.setProperty('--r',((Math.random()*240)-120)+'deg');
      field.appendChild(p);
      p.addEventListener('animationend',()=>p.remove(),{once:true});
    }
  };

  const clearPlayer=()=>{
    const audio=playerWrap.querySelector('audio');
    if(audio){audio.pause();audio.removeAttribute('src');audio.load();}
    playerWrap.replaceChildren();
    playerWrap.hidden=true;
    status.hidden=true;
    status.textContent='';
  };

  const loadPlayer=(item)=>{
    clearPlayer();
    if(item.youtube){
      const play=document.createElement('button');
      const thumbnail=document.createElement('img');
      const icon=document.createElement('span');
      play.type='button';
      play.className='mm-play';
      play.setAttribute('aria-label','Play '+item.title+' by '+item.artist);
      thumbnail.src='https://i.ytimg.com/vi/'+item.youtube+'/hqdefault.jpg';
      thumbnail.alt='';
      thumbnail.width=320;
      thumbnail.height=200;
      icon.textContent='▶';
      icon.setAttribute('aria-hidden','true');
      play.append(thumbnail,icon);
      play.addEventListener('click',()=>{
        const frame=document.createElement('iframe');
        frame.src='https://www.youtube-nocookie.com/embed/'+item.youtube+'?autoplay=1&playsinline=1&rel=0&origin='+encodeURIComponent(window.location.origin);
        frame.title=item.title+' by '+item.artist;
        frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.referrerPolicy='strict-origin-when-cross-origin';
        frame.allowFullscreen=true;
        frame.width='320';
        frame.height='200';
        playerWrap.replaceChildren(frame);
        frame.focus({preventScroll:true});
      },{once:true});
      playerWrap.appendChild(play);
      playerWrap.hidden=false;
      return;
    }
    if(item.soundcloud){
      const frame=document.createElement('iframe');
      frame.src=item.soundcloud;
      frame.title=item.title+' by '+item.artist+' — SoundCloud player';
      frame.className='mm-soundcloud';
      frame.allow='autoplay; encrypted-media';
      frame.referrerPolicy='strict-origin-when-cross-origin';
      frame.width='320';
      frame.height='166';
      frame.setAttribute('scrolling','no');
      playerWrap.appendChild(frame);
      playerWrap.hidden=false;
      return;
    }
    if(item.audio){
      const audio=document.createElement('audio');
      audio.controls=true;
      audio.preload='none';
      audio.src=item.audio;
      audio.setAttribute('aria-label',item.title+' by '+item.artist);
      audio.addEventListener('error',()=>{
        status.textContent='This recording is unavailable here. Please listen at the source below.';
        status.hidden=false;
      });
      playerWrap.appendChild(audio);
      playerWrap.hidden=false;
    }
  };

  const pickItem=()=>{
    if(flowers.length<2)return flowers[0];
    let i=Math.floor(Math.random()*flowers.length);
    if(i===lastIndex)i=(i+1)%flowers.length;
    lastIndex=i;
    return flowers[i];
  };

  const showItem=(item)=>{
    titleEl.textContent=item.title;
    artistEl.textContent=item.artist || '';
    meaningEl.textContent=item.meaning || '';
    contextEl.textContent=item.context || '';
    contextEl.hidden=!item.context;
    sourceLink.href=item.source || '#';
    sourceLink.hidden=!item.source;
    sourceLink.textContent=item.youtube||item.audio||item.soundcloud?'open source':'listen at official source';
    loadPlayer(item);
    reveal.hidden=false;
    reveal.scrollTop=0;
    reveal.classList.add('mm-show');
    close.focus({preventScroll:true});
  };

  const catchBloom=(b)=>{
    if(!reveal.hidden)return;
    lastBloom=b;
    burst(b);
    showItem(pickItem());
  };

  const makeBloom=(i)=>{
    const b=document.createElement('button');
    const img=document.createElement('img');
    b.type='button';
    b.className='mm-bloom';
    b.setAttribute('aria-label','Catch a marigold');
    b.setAttribute('aria-haspopup','dialog');
    img.src=flowerSrc;
    img.alt='';
    img.width=90;
    img.height=90;
    img.draggable=false;
    b.appendChild(img);
    b.style.setProperty('--size',(44+Math.random()*40)+'px');
    b.style.left=(5+Math.random()*70)+'%';
    b.style.setProperty('--rest',(10+i*8)+'%');
    b.dataset.phase=String((i+.5)/10);
    const drift=(Math.random()*60)-30;
    b.style.setProperty('--drift-a',(drift*.35)+'px');
    b.style.setProperty('--drift-b',drift+'px');
    b.style.setProperty('--drift-c',(drift*.2)+'px');
    b.style.setProperty('--drift-d',(drift*-.45)+'px');
    listen(b,'pointerdown',()=>b.classList.add('mm-caught'));
    listen(b,'pointercancel',()=>b.classList.remove('mm-caught'));
    listen(b,'pointerleave',()=>{if(lastBloom!==b||reveal.hidden)b.classList.remove('mm-caught');});
    listen(b,'click',()=>catchBloom(b));
    field.appendChild(b);
  };

  const makePetal=(i)=>{
    const p=document.createElement('span');
    p.className='mm-petal';
    p.setAttribute('aria-hidden','true');
    const w=5+Math.random()*9;
    const drift=(Math.random()*50)-25;
    p.style.setProperty('--w',w+'px');
    p.style.setProperty('--h',(w*1.8)+'px');
    p.style.left=(5+Math.random()*85)+'%';
    p.dataset.phase=String((i+.5)/20);
    p.style.setProperty('--drift-a',(drift*.65)+'px');
    p.style.setProperty('--drift-b',drift+'px');
    p.style.setProperty('--drift-c',(drift*-.3)+'px');
    field.appendChild(p);
  };

  for(let i=0;i<10;i++)makeBloom(i);
  for(let i=0;i<20;i++)makePetal(i);

  const sizeGarden=()=>{
    const travel=root.clientHeight+200;
    root.style.setProperty('--mm-travel',travel+'px');
    field.querySelectorAll('.mm-bloom,.mm-petal').forEach((el,i)=>{
      const duration=travel/(48+(i%7)*5);
      el.style.setProperty('--dur',duration+'s');
      el.style.setProperty('--delay',(-Number(el.dataset.phase)*duration)+'s');
    });
  };
  sizeGarden();
  const resizeObserver=new ResizeObserver(sizeGarden);
  resizeObserver.observe(root);
  const updateMotion=()=>root.classList.toggle('mm-idle',document.hidden||!inView);
  const visibilityObserver=new IntersectionObserver(entries=>{
    inView=entries[0].isIntersecting;
    updateMotion();
  });
  visibilityObserver.observe(root);
  listen(document,'visibilitychange',updateMotion);
  updateMotion();

  const hide=()=>{
    reveal.hidden=true;
    reveal.classList.remove('mm-show');
    clearPlayer();
    field.querySelectorAll('.mm-caught').forEach(b=>b.classList.remove('mm-caught'));
    if(lastBloom?.isConnected)lastBloom.focus({preventScroll:true});
  };
  listen(close,'click',hide);
  listen(again,'click',hide);
  listen(document,'keydown',event=>{
    if(event.key==='Escape'&&!reveal.hidden){event.preventDefault();hide();}
  });
  listen(document,'shopify:section:unload',event=>{
    if(!event.target.contains(root))return;
    clearPlayer();
    resizeObserver.disconnect();
    visibilityObserver.disconnect();
    controller.abort();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
